export async function fetchMenuItem(id: id) {
  const {
    attributes: menuItem,
    pending,
    error,
    refresh,
  } = await useApiFetch<ContentMenuItem>(`/api/v1/cms/menu_items/${id}`)
  return { menuItem, pending, error, refresh }
}

export async function fetchMenuItems(
  query?: SearchParameters | Ref<SearchParameters>,
) {
  const {
    attributes: menuItems,
    pending,
    error,
    refresh,
  } = await useApiFetch<ContentMenuItem[]>(
    '/api/v1/cms/menu_items',
    { query: { ...query, ...{ 'page[size]': 1_000_000 } } },
    false,
  )
  return { menuItems, pending, error, refresh }
}

type OptionalFields = {
  // Order is required for existing menu items, but not for creation payloads.
  order?: number | null
}
export interface MenuItemPayload
  extends Omit<
      ContentMenuItem,
      'id' | 'path' | 'order' | 'createdAt' | 'updatedAt'
    >,
  OptionalFields {}

export async function createMenuItem(attributes: MenuItemPayload) {
  const { data: menuItem } = await $api<JSONAPIResponse<ContentMenuItem>>(
    '/api/v1/cms/menu_items',
    {
      method: 'POST',
      body: {
        data: {
          type: 'menuItem',
          attributes: attributes,
        },
      },
    },
  )

  return menuItem
}

export async function updateMenuItem(id: id, attributes: MenuItemPayload) {
  const { data: menuItem } = await $api<JSONAPIResponse<ContentMenuItem>>(
    `/api/v1/cms/menu_items/${id}`,
    {
      method: 'PATCH',
      body: {
        data: {
          type: 'menuItem',
          attributes: attributes,
        },
      },
    },
  )

  return menuItem
}

export async function deleteMenuItem(id: id) {
  await $api<JSONAPIResponse<Vacancy>>(`/api/v1/cms/menu_items/${id}`, {
    method: 'DELETE',
  })
}
